var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShow)?_c('div',{staticClass:"chat-notification"},[_c('span',{staticClass:"notification-text"},[_vm._v(_vm._s(_vm.currentMessage))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }